import React, { useEffect } from "react";
import { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ThemeContext } from "../../contexts/ThemeContext";
import { Grid, Typography, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { useState } from "react";
import { projectsData } from "../../data/projectsData";
import "./style.css";
import { IoMdArrowRoundBack } from "react-icons/io";

const ProjectDetail = () => {
    const { id } = useParams();
    const [projectDetail, setProjectDetail] = useState({});
    const { theme } = useContext(ThemeContext);
    const history = useHistory();
    const appTheme = useTheme();
    const isMobile = useMediaQuery(appTheme.breakpoints.down("xs"));
    const useStyles = makeStyles((t) => ({
        projectDetailsPage: {
            height: "100vh",
        },
        projectContainer: {
            height: "100%",
            flexDirection: "column",
        },
        titleContainer: {
            flexDirection: 'row',
            backgroundColor: theme.primary,
            flex: 1,
            maxHeight: isMobile ? '100px' : '8rem',
            "& .MuiGrid-grid-md-8": {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            "& .MuiGrid-grid-md-4": {
                backgroundImage: `url(${projectDetail.image})`,
                backgroundSize: 'contain',
                backgroundPosition: "center",
                height: '100%',
                width: "100%",
                display: "block",
                backgroundRepeat: 'no-repeat'
            },
            "& .MuiTypography-h3": {
                color: theme.secondary,
                fontFamily: 'var(--primaryFont)',
                fontWeight: 500,
                fontSize: isMobile && '2rem',
                paddingLeft: isMobile && '3rem'
            },
            "& .MuiGrid-grid-xs-12": {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
        },
        contentContainer: {
            backgroundColor: theme.secondary,
            flex: 2,
            overflowY: 'auto'
        },
        backNav: {
            color: theme.secondary,
            position: "absolute",
            left: 25,
            padding: "7px",
            borderRadius: "50%",
            boxSizing: "content-box",
            fontSize: "2rem",
            cursor: "pointer",
            boxShadow:
                theme.type === "dark"
                    ? "3px 3px 6px #ffffff40, -3px -3px 6px #00000050"
                    : "3px 3px 6px #ffffff40, -3px -3px 6px #00000050",
            transition: "all 0.3s ease-in-out",
            "&:hover": {
                color: theme.tertiary,
                transform: "scale(1.1)",
            },
            [t.breakpoints.down("sm")]: {
                fontSize: "1.8rem",
            },
        },
        listContainer: { padding: '3rem', textAlign: "left" },
        listItems: {
            color: '#cbcbcb',
            fontFamily: 'var(--primaryFont)',
            fontSize: '20px',
            fontWeight: 500,
            padding: '12px'
        }
    }));


    const classes = useStyles();

    useEffect(() => {
        const project = projectsData?.find(project => project.id.toString() === id.toString())
        setProjectDetail(project)
    }, [id]);


    return (
        <div className={classes.projectDetailsPage}>
            <Helmet>
                <title>Project Details</title>
            </Helmet>
            <Grid container className={classes.projectContainer}>
                <Grid item container xs={12} className={classes.titleContainer} >
                    <Grid item xs={12} md={8}>
                        <IoMdArrowRoundBack
                            className={classes.backNav}
                            onClick={() => {
                                history.goBack();
                            }}
                        />
                        <Typography variant="h3" align="left">{projectDetail.projectName}</Typography>
                    </Grid>
                    {!isMobile && <Grid item md={4}></Grid>}
                </Grid>
                <Grid item xs={12} className={classes.contentContainer}>
                    <ul className={classes.listContainer}>
                        {projectDetail?.contribution?.map((contribution, index) => (
                            <li key={index} className={classes.listItems}>{contribution}</li>
                        ))}
                    </ul>
                </Grid>
            </Grid>
        </div>
    );
};

export default ProjectDetail;
